import DrawerProProduct from "./DrawerProProduct.js";

export default class ConfiguratorEventHandler {
  static METHODS = {
    NAV_BUTTONS: {
      CLOSE_BUTTON: () => {
        document.getElementById("drp-config").style.display = "none";
      },
      BACK_BUTTON: (DrawerPro) => {
        console.log("back btn clicked");

        if (DrawerPro.Glide.index !== 0) {
          if (DrawerPro.currentStep.stepName == "review-page") {
            DrawerPro.resetReviewPage();
          }

          DrawerPro.Glide.go("<");
        }

        DrawerPro.__refreshNavBtnStates();
      },
      NEXT_BUTTON: (DrawerPro) => {
        console.log("next btn clicked");

        if (DrawerPro.Glide.index === 0) {
          DrawerPro.filterSteps();
        }

        DrawerPro.toolsSelected = DrawerPro.checkToolSelection();

        // process all of the selected quantity selectors if we're not on the tool/colour selection page or the review page
        if (
          !DrawerPro.currentStep.stepName.includes("select") &&
          !DrawerPro.currentStep.stepName.includes("review-page")
        ) {
          DrawerPro.processToolSelectionToCartList();
          DrawerPro.saveState();
        }

        // re-init all conditionally rendered coloured holder images
        if (DrawerPro.currentStep.stepName.includes("colours")) {
          DrawerPro.__initHolderImages();
        }

        if (DrawerPro.Glide.index < DrawerPro.NumSteps - 1) {
          const firstOrSecondStep =
            DrawerPro.currentStep.stepName.includes("tools") ||
            DrawerPro.currentStep.stepName.includes("colours");

          if (
            (firstOrSecondStep && DrawerPro.toolsSelected) ||
            !firstOrSecondStep
          ) {
            DrawerPro.Glide.go(">");
          }
        }

        DrawerPro.__refreshNavBtnStates();
      },
      ATC_BUTTON: (DrawerPro) => {
        let products = [];

        // add all SKUs with product cards that are: visible && qty selector > 0 to the cart
        [...DrawerPro.Selectors.ProductCards]
          .filter((card) => card.style.display === "flex")
          .forEach((card) => {
            const variant = DrawerProProduct.SHOPIFY_PRODUCTS.filter(
              (variant) => variant.id == card?.dataset?.drpVariantId
            );
            //const maxQty = variant[0].inventory_quantity || 0;
            const maxQty = parseInt(card?.dataset?.drpInventoryQuantity || 0);

            products.push({
              id: card?.dataset?.drpVariantId || null,
              quantity: Math.min(
                card.querySelector(".qty-selector__input").value || 0,
                maxQty
              ),
              properties: {
                _bought_from_drawerpro_configurator: true,
              },
            });
          });

        const formData = { items: products };

        window
          .fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          })
          .then((response) => {
            // update cart and close the configurator
            DrawerPro.updateCartContent();
            // close the configurator
            document.querySelector("#drp-config").style.display = "none";

            // push "configurator completed" event
            window.dataLayer.push({
              event: "completed_drawerpro_configurator",
            });

            return response.json();
          })
          .then((result) => console.log(result))
          .catch((error) => console.warn("Error with adding to cart: ", error));
      },
    },
    QTY_SELECTORS: {
      DECREMENT: (DrawerPro, decBtn) => {
        console.log("clicked decrement");
        const associatedInput = document.querySelector(
          `input#${decBtn?.dataset?.inputLink}`
        );

        if (
          DrawerPro.validateInteger(associatedInput.value) &&
          parseInt(associatedInput.value) - 1 >= 0
        ) {
          associatedInput.value = parseInt(associatedInput.value) - 1;

          if (DrawerPro.currentStep.stepName != "review-page") {
            DrawerPro.processToolSelectionToCartList();
            DrawerPro.saveState();

            const label = DrawerPro.getQtySelectorLabel(decBtn);
            const values = DrawerPro.processCurrentStepSelections(
              associatedInput.dataset.toolId,
              parseInt(associatedInput.value)
            );

            DrawerPro.updateCurrentStepSelectionsObj(label, values);
            DrawerPro.pushCurrentStepSelections();
          }
        }

        DrawerPro.__refreshNavBtnStates();
      },
      INCREMENT: (DrawerPro, incBtn) => {
        console.log("clicked increment");
        const associatedInput = document.querySelector(
          `input#${incBtn?.dataset?.inputLink}`
        );

        if (
          DrawerPro.validateInteger(associatedInput.value) &&
          parseInt(associatedInput.value) + 1 >= 0
        ) {
          associatedInput.value = parseInt(associatedInput.value) + 1;

          if (DrawerPro.currentStep.stepName != "review-page") {
            DrawerPro.processToolSelectionToCartList();
            DrawerPro.saveState();

            const label = DrawerPro.getQtySelectorLabel(incBtn);
            const values = DrawerPro.processCurrentStepSelections(
              associatedInput.dataset.toolId,
              parseInt(associatedInput.value)
            );

            DrawerPro.updateCurrentStepSelectionsObj(label, values);
            DrawerPro.pushCurrentStepSelections();
          }
        }

        DrawerPro.__refreshNavBtnStates();
      },
      INPUT_FOCUSOUT: (DrawerPro, inputEl) => {
        if (
          DrawerPro.validateInteger(inputEl.value) &&
          parseInt(inputEl.value) >= parseInt(inputEl.attributes.min.value)
        ) {
          inputEl.value = parseInt(inputEl.value);
        } else {
          inputEl.value = 0;
        }

        if (DrawerPro.currentStep.stepName != "review-page") {
          DrawerPro.processToolSelectionToCartList();
          DrawerPro.saveState();

          const label = DrawerPro.getQtySelectorLabel(inputEl);
          const values = DrawerPro.processCurrentStepSelections(
            inputEl.dataset.toolId,
            parseInt(inputEl.value)
          );

          DrawerPro.updateCurrentStepSelectionsObj(label, values);
          DrawerPro.pushCurrentStepSelections();
        }

        DrawerPro.__refreshNavBtnStates();
      },
    },
    TOOL_SELECTIONS: {
      TOOL_SELECTION_BOX: (DrawerPro, toolSelectionBox) => {
        console.log("tool selection clicked");
        DrawerPro.toggleToolSelection(toolSelectionBox);
        DrawerPro.__refreshNavBtnStates();
      },
      SELECT_ALL_TOOLS: (DrawerPro) => {
        console.log("select all clicked");

        const allSameState =
          [...DrawerPro.Selectors.ToolSelections].filter((e) =>
            e?.className.includes("active")
          ).length === [...DrawerPro.Selectors.ToolSelections].length;

        DrawerPro.Selectors.ToolSelections.forEach((toolSelectionBox) => {
          if (allSameState) {
            DrawerPro.toggleToolSelection(toolSelectionBox);
          } else {
            DrawerPro.toggleToolSelection(toolSelectionBox, true);
          }
        });

        DrawerPro.__refreshNavBtnStates();
      },
    },
    GLIDE: {
      RUN_AFTER: (DrawerPro) => {
        console.log("'run_after' ran");

        const currentActiveSlide = document.querySelector(
          ".glide__slide--active .drp-step"
        )?.dataset?.stepId;

        DrawerPro.currentStep.index =
          DrawerPro.StepMap.indexOf(currentActiveSlide);
        DrawerPro.currentStep.stepName = currentActiveSlide;

        DrawerPro.setSelectionBoxState();

        DrawerPro.State.set("currentStep", DrawerPro.currentStep);
        DrawerPro.saveState();

        // Reset the sidepanel
        DrawerPro.currentStep.selections = {};
        DrawerPro.Selectors.SidePanelBody.innerHTML = "";

        // Populate the sidepanel
        DrawerPro.populateSelectionBox();

        if (DrawerPro.currentStep.stepName === "review-page") {
          DrawerPro.reviewPageHandler();
        }
        if (DrawerPro.currentStep.stepName === "select-colours") {
          DrawerPro.colourSelectionHandler();
        }

        DrawerPro.updateStepLabel();
        DrawerPro.__refreshNavBtnStates();

        const progress =
          ((DrawerPro.currentStep.index + 1) / DrawerPro.StepMap.length) * 100;
        DrawerPro.Selectors.ProgressBar.style.width = `${progress}%`;
      },
    },
    COLOUR_SWATCHES: (DrawerPro, swatchEl) => {
      console.log("colour clicked");

      if (swatchEl.checked) {
        document.querySelector(`input[id="${swatchEl?.dataset?.for}"]`).value =
          swatchEl.value;

        if (swatchEl?.dataset?.for.includes("metric")) {
          DrawerPro.colourSelections.metric = swatchEl.value;
        } else if (swatchEl?.dataset?.for.includes("sae")) {
          DrawerPro.colourSelections.sae = swatchEl.value;
        } else if (swatchEl?.dataset?.for.includes("other")) {
          DrawerPro.colourSelections.other = swatchEl.value;
        }

        DrawerPro.State.set("colourSelections", DrawerPro.colourSelections);
        DrawerPro.saveState();
      }

      DrawerPro.colourSelectionHandler();
      DrawerPro.__refreshNavBtnStates();
    },
    MODALS: {
      TRANSFER_MODAL_TRIGGER: (DrawerPro) => {
        console.log("transer modal trigger clicked");
        console.log(DrawerPro.Selectors.QRCodeCanvas);

        const url = DrawerPro.generateHashedURL(DrawerPro.State);
        DrawerPro.QRCode.set({
          size: 400, // TODO: test out super upscaling this size and just using CSS to downscale it with a class rule.
          value: url,
        });

        document.getElementById("copyTextField").value = url;
      },
    },
  };
}
